import { FC, SVGProps } from "react";

const ThirtyIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="56"
      height="47"
      viewBox="0 0 56 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        opacity=".3"
        cx="14.5"
        cy="14.5"
        r="14.5"
        transform="matrix(1 0 0 -1 27 29)"
        fill="#4BB1E9"
      />
      <path
        d="M12.976 32.16c-.747 0-1.392-.09-1.936-.272-.544-.181-.997-.416-1.36-.704a3.31 3.31 0 0 1-.8-.96 2.429 2.429 0 0 1-.288-1.04c0-.096.032-.17.096-.224a.382.382 0 0 1 .256-.096h1.44a.54.54 0 0 1 .272.064c.075.043.139.128.192.256.096.288.25.517.464.688.224.17.48.293.768.368.288.064.592.096.912.096.64 0 1.147-.15 1.52-.448.384-.31.576-.747.576-1.312 0-.565-.176-.97-.528-1.216-.352-.256-.843-.384-1.472-.384H11.44a.427.427 0 0 1-.288-.096.39.39 0 0 1-.112-.288v-.672a.54.54 0 0 1 .064-.272c.053-.085.107-.155.16-.208l2.864-2.8H9.552a.39.39 0 0 1-.288-.112.404.404 0 0 1-.096-.272V21.2c0-.117.032-.213.096-.288a.39.39 0 0 1 .288-.112h6.864a.39.39 0 0 1 .288.112.39.39 0 0 1 .112.288v.96a.507.507 0 0 1-.064.256.904.904 0 0 1-.144.192l-2.768 2.848.192.016c.65.053 1.227.203 1.728.448a2.62 2.62 0 0 1 1.184 1.04c.288.459.432 1.035.432 1.728 0 .725-.192 1.35-.576 1.872-.373.512-.89.907-1.552 1.184-.661.277-1.419.416-2.272.416Z"
        fill="#2C2C2C"
      />
      <circle
        cx="26.12"
        cy="27.069"
        r="5.331"
        stroke="#2C2C2C"
        strokeWidth="1.2"
      />
      <path
        stroke="#2C2C2C"
        strokeLinecap="round"
        opacity=".3"
        d="m26.663 23.726-.002-.52m.002 7.768v-.459m1.482-5.952.436-.437m-4.04 6.51.301-.302m-.015-6.217-.284-.426m4.039 6.25-.302-.301m1.079-3.843.484-.393m-6.74 3.847.406-.207M23.03 25l.377.257m6.421 3.158-.421-.26m.26-.834.534-.022m-7.785.156h.459"
      />
      <rect x="25" y="19" width="3" height="1" rx=".5" fill="#2C2C2C" />
      <path
        stroke="#2C2C2C"
        strokeWidth="1.2"
        strokeLinecap="round"
        d="M26.6 19.6v1.8"
      />
      <rect
        x="20.189"
        y="22.89"
        width="2.424"
        height=".831"
        rx=".415"
        transform="rotate(-45 20.189 22.89)"
        fill="#2C2C2C"
      />
      <path
        stroke="#2C2C2C"
        strokeWidth="1.2"
        strokeLinecap="round"
        d="m21.748 22.748-.137-.137"
      />
      <rect
        width="2.344"
        height=".859"
        rx=".429"
        transform="scale(1.03122 .96777) rotate(45 -11.745 47.487)"
        fill="#2C2C2C"
      />
      <path
        transform="scale(-1.03122 -.96777) rotate(-45 -42.662 25.245)"
        stroke="#2C2C2C"
        strokeWidth="1.2"
        strokeLinecap="round"
        d="M.6-.6h.448"
      />
      <path
        d="M3.33 46.003v-8.89h8.89"
        stroke="#2C2C2C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.998 26.002c0 11.046-8.954 20.001-20 20.001-6.284 0-12.422-3.73-16.088-8.261M38 5v10h-9"
        stroke="#2C2C2C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 26.001C1 14.955 9.955 6 21.001 6c6.283 0 12.421 3.73 16.088 8.261"
        stroke="#2C2C2C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ThirtyIcon;
